/* @flow */

import * as React from 'react';
import { useLocation } from 'react-router-dom';

import { scrollToTop } from 'src/shared/core/util/browserUtil';

type Props = {
  children: React.Node,
};

const ScrollToTop = ({ children }: Props): React.Node => {
  /*
   |----------------------------------------------------------------------------
   | Hooks
   |----------------------------------------------------------------------------
   */

  const location = useLocation();

  /*
   |----------------------------------------------------------------------------
   | Effects
   |----------------------------------------------------------------------------
   */

  React.useEffect(() => {
    scrollToTop();
  }, [location.pathname]);

  /*
   |----------------------------------------------------------------------------
   | Elements
   |----------------------------------------------------------------------------
   */

  return children;
};

export default React.memo<Props>(ScrollToTop);
